<template>
  <Usuario />
</template>

<script>
import Usuario from "@/components/cadastros/Cadastros";

export default {
  components: {
    Usuario
  },
  mounted() {
    this.$store.dispatch("MenuParametrizacaoIncludes/atualizarMenuParaAreaDeUsuario", this.$route.path);
  },
}
</script>

<style>

</style>
